import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import StackView from '../StackView';
import { useThemeValue } from '../system';
import { cloneChildren } from '../utils';
export function Group(_ref) {
  var _ref$axis = _ref.axis,
      axis = _ref$axis === void 0 ? 'horizontal' : _ref$axis,
      childProps = _ref.childProps,
      children = _ref.children,
      radius = _ref.radius,
      spacing = _ref.spacing,
      restProps = _objectWithoutPropertiesLoose(_ref, ["axis", "childProps", "children", "radius", "spacing"]);

  var themeRadius = useThemeValue('group.radius');
  var radiusValue = radius != null ? radius : themeRadius;
  var isHorizontalLayout = axis === 'horizontal';
  var startRadius = isHorizontalLayout ? 'radiusLeft' : 'radiusTop';
  var endRadius = isHorizontalLayout ? 'radiusRight' : 'radiusBottom';
  var marginBottom = isHorizontalLayout ? 0 : '-1px';
  var marginRight = isHorizontalLayout ? '-1px' : 0;
  return /*#__PURE__*/React.createElement(StackView, _extends({
    axis: axis,
    spacing: spacing
  }, restProps), cloneChildren(children, function (child, _ref2) {
    var _objectSpread2;

    var firstChild = _ref2.firstChild,
        lastChild = _ref2.lastChild;
    return _objectSpread(_objectSpread(_objectSpread({}, childProps), {}, (_objectSpread2 = {}, _objectSpread2[startRadius] = firstChild ? radiusValue : 0, _objectSpread2[endRadius] = lastChild ? radiusValue : 0, _objectSpread2), !spacing && !lastChild && {
      marginBottom: marginBottom
    }), !spacing && !lastChild && {
      marginRight: marginRight
    });
  }));
}